// Copyright (c) RoochNetwork
// SPDX-License-Identifier: Apache-2.0

export const ROOCH_ADDRESS_LENGTH = 64
